import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import SidebarComponent from "../Reusables/SidebarComponent";
import styles from "./AnnualPassContractStatus.module.css";
import useAxios from "../Hooks/useAxios";
import { useNavigate } from "react-router-dom";
import cart_r from "../../assets/images/cart_r.png";

const AnnualPassContractStatus = () => {
  const passColorObject = {
    1: "#EFEEE5",
    2: "#D9DEE3",
    3: "#CCCCCC",
    4: "#E8DBB3",
    5: "#ABC4B9",
  };

  const [popup, setPopup] = useState(false);
  const [items, setItems] = useState([]);
  const [purchasedAnnualPass, setPurchasedAnnualPass] = useState({});

  const axios = useAxios();
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const handleOpenPopup = () => {
    setPopup(true);
    axios
      .get(backend_base + "/maintenance/annual-pass/purchase")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success", res.data);
          setItems(res.data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleClosePopup = () => {
    setPopup(false);
  };

  const handleAddToCart = (item) => {
    const data = {
      annual_pass_id: item.id,
    };
    axios
      .post(backend_base + "/maintenance/annual-pass/cart", data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success");
          navigate("/cart-annual-pass");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  console.log(purchasedAnnualPass);

  useEffect(() => {
    axios
      .get(backend_base + "/maintenance/annual-pass")
      .then((res) => {
        if (res.status === 200) {
          console.log("Success", res.data);
          if (res.data?.length > 0) {
            setPurchasedAnnualPass(res.data[res.data.length - 1]);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  return (
    <div>
      <Header />
      <div className={styles.annualContractParent}>
        <div className={styles.sidebar_wrapper01}>
          <SidebarComponent />
        </div>
        <div className={styles.annualContractMiddle}>
          <h5 className={styles.annualContractHeader}>年間保管パス契約状況</h5>
          <div className={styles.annualPassMainDiv}>
            <div className={styles.passTypeContainer}>
              <div
                className={styles.passTypeDiv}
                style={{
                  backgroundColor:
                    passColorObject[purchasedAnnualPass?.pass_type],
                }}
              >
                <span>
                  {purchasedAnnualPass?.pass_type}
                  年 <br /> PASS
                </span>
              </div>
              <span style={{ alignSelf: "center", fontWeight: "bold" }}>
                ご利用中
              </span>
            </div>
            <div className={styles.storagePeriod}>
              <span>ギャラリー保管期限</span>
              <span>{purchasedAnnualPass?.expiry_date}</span>
            </div>
            <div className={styles.storageAmount}>
              <div className="d-flex justify-content-between">
                <div>使用容量</div>
                <div
                  style={{
                    textAlign: "left",
                    width: "50px",
                  }}
                >
                  {purchasedAnnualPass?.storage}MB
                </div>
              </div>
              <div className="d-flex justify-content-between">
                <div>空き容量</div>
                <div
                  style={{
                    textAlign: "left",
                    width: "50px",
                  }}
                >
                  {purchasedAnnualPass?.free_space}MB
                </div>
              </div>
            </div>
          </div>
          <div className="w-100 d-flex flex-column align-items-center mt-5">
            <button
              className={`btn ${styles.annualContractBtn}`}
              onClick={handleOpenPopup}
            >
              継続またはパスの変更
            </button>
            <div
              className={`d-flex justify-content-center my-2 ${styles.renewalTxtStyle}`}
            >
              <span>更新期限</span>
              <span className="ml-2">{purchasedAnnualPass?.expiry_date}</span>
            </div>
          </div>
          <div className={`${styles.annualContractBottomDiv}`}>
            <h5 className={styles.annualContractBottomHeader}>
              継続・変更の際の保管期限
            </h5>
            <div className={styles.annualContractBottomTxt}>
              更新期限前に、「継続・もしくは変更」のお手続きをされた場合 、
              <br />
              保管期間終了日から1年間（もしくは契約の年数分）保管期限が延長されます。
              <br />
              例）現在契約中の年間パスの保管期間終了日が 2023/05/03で、
              <br />
              　　2023/04/20に1年保管パスを購入された場合→2024/05/03まで保管されます。
            </div>
          </div>
        </div>
      </div>
      {popup && (
        <div className={styles.popup_main}>
          <div className={styles.popup}>
            <span className={styles.cross} onClick={() => handleClosePopup()}>
              X
            </span>
            <div className={styles.content}>
              <h5 className={styles.bold}>
                ギャラリーに保管する年数を選んでカートに入れてください。
              </h5>
              <div className={styles.main_content}>
                <p>
                  3ヶ月の無料保管期間を過ぎた後も、MyAceにギャラリーを保管できるサービスです。（最大10Gまで）
                  <br></br>
                  延長する年数をお選びの上お手続きください。（銀行振り込み不可）
                </p>
                <p>
                  年間パスの期限が終了する前に再度、年間パスをご購入いただくと保管期限は延長されます。
                  <br></br>
                  年間パスが切れてしまうと、データを購入していただくこととなりますのでご注意ください。（1プラン￥1,650）
                </p>
                <div>
                  <table className={styles.items}>
                    <tbody>
                      {Array.isArray(items) &&
                        items.length > 0 &&
                        items.map((item, index) => (
                          <tr className={styles.tr} key={index}>
                            <td>
                              <div
                                className={styles.pass}
                                style={{
                                  backgroundColor: passColorObject[index + 1],
                                }}
                              >
                                {item.name.length > 0 &&
                                  item.name.split(" ")[0]}
                                <br />
                                PASS
                              </div>
                            </td>
                            <td className={styles.year}>{item.year}年保管</td>
                            <td className={styles.money}>
                              {new Intl.NumberFormat("ja-JP", {
                                style: "currency",
                                currency: "JPY",
                              }).format(item.price)}
                            </td>
                            <td>
                              <button
                                className={styles.add_to_cart}
                                onClick={() => handleAddToCart(item)}
                              >
                                <img src={cart_r} alt="cart_icon" />
                                <span>カートに入れる</span>
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default AnnualPassContractStatus;
